import React, { useState } from 'react';
import { X } from 'lucide-react';
import crm from './api';

// Manual "Add Inquiry" — lets a rep log a lead by hand (walk-up, phone call, a card
// the customer couldn't tap). Posts to /crm-api/leads, which owns it to the rep,
// auto-tags the running conference, books a first call and notifies them.
export default function LeadQuickAdd({ onClose, onCreated }) {
  const [f, setF] = useState({ name: '', phone: '', company: '', city: '', email: '', interest: '', message: '' });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const phoneDigits = f.phone.replace(/[^\d]/g, '');
  const ok = f.name.trim() && phoneDigits.length >= 8 && phoneDigits.length <= 15;

  const submit = async (e) => {
    e.preventDefault();
    if (!ok || busy) return;
    setBusy(true); setErr('');
    try {
      await crm.post('/leads', {
        name: f.name.trim(), phone: f.phone.trim(),
        company: f.company.trim() || undefined, city: f.city.trim() || undefined,
        email: f.email.trim() || undefined, interest: f.interest.trim() || undefined,
        message: f.message.trim() || undefined, source: 'manual',
      });
      onCreated && onCreated();
    } catch (e2) {
      setErr(e2.response?.data?.error || 'Could not add the inquiry. Please try again.');
    } finally { setBusy(false); }
  };

  const inp = { width: '100%', padding: '10px 12px', marginTop: 5, borderRadius: 10, border: '1px solid var(--border)', background: 'var(--card)', color: 'var(--text)', fontSize: 14, outline: 'none' };
  const lbl = { fontSize: 11, textTransform: 'uppercase', letterSpacing: .6, color: 'var(--muted)', fontWeight: 700 };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, zIndex: 60 }} onClick={onClose}>
      <div style={{ width: '100%', maxWidth: 460, background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 18, padding: 22, maxHeight: '90vh', overflowY: 'auto' }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <div style={{ fontSize: 17, fontWeight: 800, color: 'var(--text)' }}>Add Inquiry</div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--muted)' }}><X size={22} /></button>
        </div>

        {err && <div style={{ background: '#fef2f2', color: '#991b1b', border: '1px solid #fecaca', padding: '8px 12px', borderRadius: 10, fontSize: 13, marginBottom: 12 }}>{err}</div>}

        <form onSubmit={submit}>
          <label style={lbl}>Name *</label>
          <input style={inp} value={f.name} onChange={set('name')} placeholder="Customer name" autoFocus />
          <div style={{ height: 12 }} />
          <label style={lbl}>WhatsApp Number *</label>
          <input style={inp} type="tel" value={f.phone} onChange={set('phone')} placeholder="+91 98765 43210" />
          <div style={{ height: 12 }} />
          <div style={{ display: 'flex', gap: 12 }}>
            <div style={{ flex: 1 }}><label style={lbl}>Business / Clinic</label><input style={inp} value={f.company} onChange={set('company')} placeholder="e.g. Apollo Clinic" /></div>
            <div style={{ flex: 1 }}><label style={lbl}>City</label><input style={inp} value={f.city} onChange={set('city')} placeholder="e.g. Chennai" /></div>
          </div>
          <div style={{ height: 12 }} />
          <label style={lbl}>Email</label>
          <input style={inp} type="email" value={f.email} onChange={set('email')} placeholder="name@example.com" />
          <div style={{ height: 12 }} />
          <label style={lbl}>Interest / Product</label>
          <input style={inp} value={f.interest} onChange={set('interest')} placeholder="e.g. Advanced Foot Lab" />
          <div style={{ height: 12 }} />
          <label style={lbl}>Remarks</label>
          <textarea style={{ ...inp, minHeight: 60, resize: 'none' }} value={f.message} onChange={set('message')} placeholder="Anything discussed" />
          <button type="submit" disabled={!ok || busy}
            style={{ width: '100%', marginTop: 18, padding: 12, borderRadius: 10, border: 'none', cursor: ok && !busy ? 'pointer' : 'default', fontWeight: 700, fontSize: 14.5, color: '#fff', background: '#0b6e3e', opacity: ok && !busy ? 1 : 0.5 }}>
            {busy ? 'Adding…' : 'Add Inquiry'}
          </button>
        </form>
      </div>
    </div>
  );
}
